import React, { useState } from "react";

type InputProps = {
  placeholder?: string;
  value?: string;
  className?: string;
  name?: string;
  type?: string;
  onChange?: any;
  onPressEnter?: any;
  status?: "error" | "warning" | "";
  validationMessage?: string;
  autocomplete?: "on" | "off";
  ref?: any;
};

const Input = (props: InputProps) => {
  const [value, setValue] = useState(props.value || "");

  const handleOnChange = (e) => {
    setValue(e.target.value);
    props.onChange && props.onChange(e);
  };

  const handleEnterButton = (e) => {
    if (e.key === "Enter") {
      props.onPressEnter(e);
    }
  };

  return (
    <div className={`dataentry-container ${props.status}`}>
      <input
        placeholder={props.placeholder}
        value={props.value}
        name={props.name}
        type={props.type || "text"}
        className={`input ${props.className}`}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnChange(e)}
        autoComplete={props.autocomplete || "off"}
        onKeyDown={props.onPressEnter && handleEnterButton}
        ref={props.ref}
      />
      <p className="validation-message">{props.validationMessage}</p>
    </div>
  );
};

export default Input;
